import { render, staticRenderFns } from "./waterUsageTermsPopup.vue?vue&type=template&id=5bf6d41a&scoped=true"
import script from "./waterUsageTermsPopup.vue?vue&type=script&lang=js"
export * from "./waterUsageTermsPopup.vue?vue&type=script&lang=js"
import style0 from "./waterUsageTermsPopup.vue?vue&type=style&index=0&id=5bf6d41a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf6d41a",
  null
  
)

export default component.exports